( function ( _s ) {
	_s( document ).ready( () => {
		const _header = _s( '#app > header' );
		const _wpAdminBar = _s( '#wpadminbar' );
		const _logo = _s( '.navbar-brand' );
		let locked = false;

		const setBodyTopPadding = () => {
			if ( ! locked ) {
				const headerHeight = _header.outerHeight();
				const wpAdminBarHeight = _wpAdminBar.length ? _wpAdminBar.outerHeight() : 0;
				const logoHeight = _logo.length ? _logo.outerHeight() : 0;
				let height = headerHeight + wpAdminBarHeight;

				if ( logoHeight > height ) {
					height = logoHeight;
				}

				window.setRootProperty( '--body-top-padding', height + 'px' );

				_s( window ).trigger( 'fr:set-body-top-padding-updated' );
			}
		};

		_s( window ).on( 'fr:set-body-top-padding', () => {
			setBodyTopPadding();
		} );

		_s( window ).on( 'fr:unlock-body-top-padding', () => {
			locked = false;
			setBodyTopPadding();
		} );

		if ( window.location.hash.length ) {
			locked = true;
		} else {
			setBodyTopPadding();
		}
	} );
} )( window._s );
